import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import KML from "ol/format/KML";
import GPX from "ol/format/GPX";
import GeoJSON from "ol/format/GeoJSON";
import { unzipSync } from "fflate";
import { capaActiva } from "../capaActiva";
import { getUid } from "ol";

function getKMLData(buffer, zipHolder) {
  const zip = unzipSync(new Uint8Array(buffer));

  // guarda el zip para las imágenes
  zipHolder.zip = zip;

  const kmlFile = Object.keys(zip).find((key) =>
    key.toLowerCase().endsWith(".kml")
  );
  if (!kmlFile) return null;

  return new TextDecoder().decode(zip[kmlFile]);
}

function getKMLImageFactory(zipHolder) {
  return function (href) {
    const fileName = href.split("/").pop();
    const zip = zipHolder.zip;

    if (!zip || !(fileName in zip)) return href;

    return URL.createObjectURL(new Blob([zip[fileName]]));
  };
}

class KMZ extends KML {
  constructor(zipHolder) {
    super({
      extractStyles: true,
      iconUrlFunction: getKMLImageFactory(zipHolder),
    });
    this.zipHolder = zipHolder;
  }

  getType() {
    return "arraybuffer";
  }

  readFeatures(source, options) {
    const kmlData = getKMLData(source, this.zipHolder);
    return super.readFeatures(kmlData, options);
  }
}

export const subirCapa = (map) => {
  const inputFile = document.getElementById("fileInputKML");

  inputFile.addEventListener("change", (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const ext = file.name.split(".").pop().toLowerCase();
    const reader = new FileReader();

    if (ext === "kmz") {
      // leer como ArrayBuffer
      reader.readAsArrayBuffer(file);

      reader.onload = function (e) {
        const buffer = e.target.result;

        const zipHolder = {}; // cachear el zip
        const format = new KMZ(zipHolder);

        const features = format.readFeatures(buffer, {
          dataProjection: "EPSG:4326",
          featureProjection: map.getView().getProjection(),
        });

        const vectorLayer = new VectorLayer({
          source: new VectorSource({ features }),
        });

        map.addLayer(vectorLayer);
        map
          .getView()
          .fit(vectorLayer.getSource().getExtent(), { duration: 1000 });

        capaActiva(
          vectorLayer,
          vectorLayer.getSource().getExtent(),
          getUid(vectorLayer)
        );
      };

      return; // no seguir con KML/GPX/GeoJSON
    }

    //KML GPX GeoJSON leer como texto
    reader.readAsText(file);

    reader.onload = function (e) {
      const text = e.target.result;

      let format;

      if (ext === "kml") format = new KML({ extractStyles: true });
      else if (ext === "gpx") format = new GPX();
      else if (ext === "geojson" || ext === "json") format = new GeoJSON();
      else {
        alert("Formato no soportado: " + ext);
        return;
      }

      const features = format.readFeatures(text, {
        dataProjection: "EPSG:4326",
        featureProjection: map.getView().getProjection(),
      });

      const vectorLayer = new VectorLayer({
        source: new VectorSource({ features }),
      });

      map.addLayer(vectorLayer);

      map
        .getView()
        .fit(vectorLayer.getSource().getExtent(), { duration: 1000 });

      capaActiva(
        vectorLayer,
        vectorLayer.getSource().getExtent(),
        getUid(vectorLayer)
      );
    };
  });
};
